// Browser-console debug helpers for LazyLoadManager.
// Exposed under window.debugLazyLoad / window.forceLoadMore for manual investigation.

export function registerDebugHelpers(manager) {
    if (typeof window === 'undefined') return;

    window.lazyLoadManager = manager;

    window.debugLazyLoad = function () {
        console.log('=== 🐛 LazyLoadManager Debug Info ===');
        console.log('State:', manager.getState());
        console.log('Container:', manager.container);
        console.log('Loading indicator:', {
            element: manager.loadingIndicator,
            display: manager.loadingIndicator?.style.display,
            offsetHeight: manager.loadingIndicator?.offsetHeight,
            isVisible: manager.loadingIndicator?.offsetHeight > 0
        });
        console.log('End indicator:', {
            element: manager.endIndicator,
            display: manager.endIndicator?.style.display,
            offsetHeight: manager.endIndicator?.offsetHeight
        });
        console.log('Observer:', manager.observer);
        console.log('All files sample:', manager.allFiles.slice(0, 3));
        console.log('Displayed files sample:', manager.displayedFiles.slice(0, 3));
        console.log('=== End Debug ===');
        return manager.getState();
    };

    window.forceLoadMore = function () {
        console.log('🚀 Forcing loadMore()...');
        manager.loadMore();
    };
}
